import WebSocketClient from '@clients/web-socket.client';
import { IFamilyData, IFamilyMember, IFamilyMemberFileIdUpdate } from '@app-types/websocket/family.types';
import { IChildInfoUpdate } from '@app-types/websocket/sharedinfo.types';

const socket = WebSocketClient.getInstance();

export function addNewFamilyMember(data: IFamilyMember) {  
  socket.sendJSON({
    newFamilyMember: data,
  });
}

export function addUser(data: IFamilyMember) {  
  socket.sendJSON({
    addUser: data, 
  });
}

export function updateFamilyMember(data: IFamilyMember) {  
  socket.sendJSON({
    updateFamilyMember: data,
  });
}

export function updateFamilyMemberFileId(data: IFamilyMemberFileIdUpdate) {  
  socket.sendJSON({
    updateFamilyMemberFileId: data,
  });
}

export function deleteFamilyMember(id: number) {  
  socket.sendJSON({
    deleteFamilyMember: id,
  });
}

export function unlimitFamilyMember(id: number) {
  socket.sendJSON({
    unlimitFamilyMember: id,
  });
}

export function restoreAccount(id: number) {
  socket.sendJSON({
    restoreAccount: id,
  });
}

export function nudgeToLogIn(id: number) {
  socket.sendJSON({
    nudgeToLogin: id,
  });
}

export function selectFamilyCountry(country: string) {  
  socket.sendJSON({
    familyCountry: country,
  });
}

export function createFamily(family:IFamilyData) {  
  socket.sendJSON({
    createNewFamily: family,
  });
}

export function updateChildInfo(childInfo:IChildInfoUpdate) {  
  socket.sendJSON({
    childInfoUpdate: childInfo,
  });
}



// WEBPACK FOOTER //
// ./src/services/family/family.websocket.ts